// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Thaj","buttons":"RemoveExpirationActionButtons_buttons__2U5l7"};